import { useApolloClient } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import { useSignOutMutation } from 'apollo/queries/autogenerate/hooks';
import eventBus from 'shared/utils/event-bus';
import routes from 'web/navigation/routes';

export default function useSignOutUser() {
  const navigate = useNavigate();
  const [signOut] = useSignOutMutation();
  const apolloClient = useApolloClient();

  /**
   * @param runMutation Run the Sign Out mutation. If the refreshToken has expired, set this to false. Defaults to true.
   * @param pathName Path to redirect when signing back in.
   */
  const signOutUser = async (runMutation = true, pathName = '') => {
    // If we are impersonating an account, this clears out the sessionToken
    eventBus.emit('authToken:set', '');

    // Deletes the isAppSignedIn cookie
    eventBus.emit('auth:set', false);

    if (runMutation) {
      try {
        await signOut();
      } catch (err) {
        console.error(err);
      }
    }

    // Clears the Apollo cache
    await apolloClient.clearStore();

    // If reSignIn is true, stores reSignIn=true and next=<pathName> to the browser's History object to give option
    // to redirect to the pathname on sign in when tokens (accessToken and refreshToken) expires during use
    navigate(routes.unauthenticated.root, {
      state: pathName
        ? {
            reSignIn: true,
            next: pathName,
          }
        : null,
      // Clear the History state to avoid issues such as the SignIn screen accidentally picking
      // up the wrong path to redirect
      // TIP: We always clear the History state when we are done with it.
    });
  };

  return signOutUser;
}
